// 淡入淡出图片

import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Carousel, Form, Input, message, Modal, notification, Statistic } from 'antd';
import { useEffect, useState, useRef } from 'react';
import cookie from 'react-cookies';
import fun from '../../common/common_fun';
import url from '../../common/url_config';
import WOW from 'wowjs';
import 'wowjs/css/libs/animate.css';

function App(props) {
  let [current_language_ch, set_current_language_ch] = useState(window.location.href.indexOf('?lan=en') === -1)//当前语言是否中文

  // wow初始化
  useEffect(() => {
    new WOW.WOW({
      boxClass: 'wow', // 动画的类名
      animateClass: 'animated', // 动画应用的类名
      offset: 0, // 触发动画的位置偏移量
      mobile: true, // 是否在移动端上启用
      live: true // 如果为true，则在页面加载后动态添加的新元素也会触发动画
    }).init();
  }, []);

  return <div className='banner_top_box'>
    <div style={{ color: '#686664' }}>{current_language_ch ? '产品' : 'PRODUCT'}</div>
    <div className='fade_banner_div wow slideInRight' data-wow-duration="1s">{current_language_ch ? 'EasyEVSE 开发平台在线体验' : 'NXP EasyEVSE Development Platform Online Experience'}</div>
    <a target={'_blank'} style={{ marginTop: 15, width: current_language_ch ? 90 : 130 }} href={'/details/imx93evk-evse-1' + (current_language_ch ? '' : '?lan=en')} className='nxp-btn-primary wow slideInLeft' data-wow-duration="0.7s" >{current_language_ch ? '全新体验' : 'START HERE'}</a>
  </div>
}

export default App